import { render, staticRenderFns } from "./Recomendados.vue?vue&type=template&id=f0f70312&scoped=true"
import script from "./Recomendados.vue?vue&type=script&lang=js"
export * from "./Recomendados.vue?vue&type=script&lang=js"
import style0 from "./Recomendados.vue?vue&type=style&index=0&id=f0f70312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f70312",
  null
  
)

export default component.exports